import axios from "axios";

const { REACT_APP_BASE_URL } = process.env;

interface ResetPasswordPayload {
  newPassword: string;
  confirmPassword: string;
  resetPasswordKey: string;
  oldPassword: string | null;
}

export const resetUserPassword = async (payload: ResetPasswordPayload): Promise<void> => {
  try {
    const RESET_URL = `${REACT_APP_BASE_URL}/sc/api/user/reset-password`;
    await axios.post(RESET_URL, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    // The raw axios error carries error.config.data = the reset payload
    // (new/old passwords). Keep the message static — no variables in the log (CWE-532).
    console.error('Password reset request failed.');
    throw error;
  }
};
